<template>
  <c-page>
    <c-content>
      <c-images :img-items="images"></c-images>
      <div class="overlay-text">
        <div class="overlay-mask overlay-mask-one" @click="openLaws">
        </div>
        <div class="overlay-mask overlay-mask-two" @click="goToProtocol">
        </div>
      </div>
    </c-content>
    <c-footer class="footer-shadow">
      <c-button @click.native="buy">
        <div>立即购买</div>
        <!--<div class="small-text">买就送100M手机全国流量</div>-->
      </c-button>
    </c-footer>
  </c-page>
</template>
<style lang="scss" scoped>
  @import "../../../assets/scss/base/__mixin";
  @import "./index";
  
  .footer-shadow {
    box-shadow: 0 0 px2rem(3px) gray;
  }
  
  .small-text {
    @include font-dpr(10px);
    margin-top: px2rem(-33px);
  }
</style>
<script>
  import Pay from '../../../model/pay'
  import debounce from 'lodash.debounce'
  import Vas from '../../../model/value-added-service'
  import GoodsModel from '../../../model/goods'
  export default{
    data () {
      return {
        vas: new Vas(),
        images: [
//          require('@/assets/images/senior/senior-1.png'),
//          require('@/assets/images/senior/senior-2.png'),
//          require('@/assets/images/senior/senior-3.png')
        ],
        pay: new Pay()
      }
    },
    components: {},
    created () {
      console.log('log')
      this.vas.loadDetail(GoodsModel.saas.advanced.id).then(res => {
        this.images = res.images
      })
    },
    mounted () {},
    beforeDestroy () {},
    methods: {
      buy: debounce(function () {
        if (!this.vas.isCanBuy()) {
          this.$wejs.alert(this.vas.getErrorMess())
          return
        }
        this.pay.saasPay(GoodsModel.saas.advanced.id, 12)
      }, 220),
      openLaws () {
        this.$router.push('/user-protocol')
      },
      goToProtocol () {
        this.$router.push('/apple-auto-renew-protocol')
      }
    },
    computed: {},
    events: {}
  }
</script>



// WEBPACK FOOTER //
// index.vue?fc1fc196